import { useEffect } from "react";
import Announcements from "../components/MainPage/Announcements";
import ImageAlt from "../components/MainPage/ImageAlt";
import MobAnnouncements from "../components/MainPage/MobAnnouncements";
import SongSearch from "../components/MainPage/SongSearch";
import TestimonialWidget from "../components/MainPage/TestimonialWidget";

function IndexPage() {

  useEffect(() => {
    document.title = "Home | Keyless Online";
  }, [])
  return (
    <>
      <div className="tw-overflow-y-hidden">
        <Announcements />
        <div className="tw-z-50">
          <SongSearch />
        </div>
        <div className="tw-h-3/4 tw-w-3/4">
          <ImageAlt />
        </div>
        <div>
          <TestimonialWidget />
        </div>
        <div className="tw-block sm:tw-hidden">
          <MobAnnouncements />
        </div>
      </div>
    </>
  );
}

export default IndexPage;
